<template>
  <div>
    <div class="fy-drawer__detail" v-if="IsMobile">
      <div class="fy-drawer__detail__logo">
        <img :src="iconListM[`${$route.query.type}IconM`]" />
      </div>
      <div class="fy-drawer__detail__bottom">
        <router-link :to="$route.query.type === 'brand'? '/brand_cooperate' : `/products?type=${$route.query.type}`">
          <img :src="backIcon" />
        </router-link>
      </div>
    </div>
    <div class="big-picture__more">
      <a style="cursor: pointer;" target="_blank" v-for="product in designDetail" :href="storeUrl" :key="product"><img :src="product" /></a>
    </div>
    <div class="fy-introduction" v-if="!IsMobile">
      <div class="fy-drawer">
        <div class="fy-drawer__logo" style="padding: 80px 0">
          <img :src="iconList[`${$route.query.type}Icon`]" />
        </div>
        <div class="fy-drawer__text">
        </div>
        <div class="fy-drawer__bottom">
          <img :src="drawerBottomIcon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { IsMobile } from "@/utils";
import freshIcon from "@/assets/pc/fresh.png";
import classicIcon from "@/assets/pc/classic.png";
import diamondIcon from "@/assets/pc/diamond.png";
import frenchIcon from "@/assets/pc/french.png";
import frostedIcon from "@/assets/pc/frosted.png";
import laserIcon from "@/assets/pc/laser.png";
import pureIcon from "@/assets/pc/pure.png";
import backIcon from "@/assets/back.jpg";
import brandIcon from "@/assets/pphz—icon.png";
import freshIconM from "@/assets/mobile/fresh.png";
import classicIconM from "@/assets/mobile/classic.png";
import diamondIconM from "@/assets/mobile/diamond.png";
import frenchIconM from "@/assets/mobile/french.png";
import frostedIconM from "@/assets/mobile/frosted.png";
import laserIconM from "@/assets/mobile/laser.png";
import pureIconM from "@/assets/mobile/pure.png";
import brandIconM from "@/assets/pphz-iconM.png";
import drawerBottomIcon from "@/assets/drawer-bottom-icon@3x.png";
export default Vue.extend({
  name: "ProductsDetail",
  data() {
    return {
      designDetail: [],
      storeUrl: "",
      IsMobile,
      backIcon,
      drawerBottomIcon,
      iconList: {
        freshIcon,
        classicIcon,
        diamondIcon,
        frenchIcon,
        frostedIcon,
        pureIcon,
        laserIcon,
        brandIcon
      },
      iconListM: {
        freshIconM,
        classicIconM,
        diamondIconM,
        frenchIconM,
        frostedIconM,
        pureIconM,
        laserIconM,
        brandIconM
      },
    };
  },
  created() {
    this.getDesignDetailById(this.$route.query.id);
  },
  methods: {
    getDesignDetailById(id) {
      this.$https
        .get("/api/oilliProduct/getDesignDetailById", {
          params: {
            id,
          },
        })
        .then((res) => {
          const item = res.data.items;
          const isHorizontal = this.$route.query.size === "horizontal";
          this.designDetail = isHorizontal
            ? JSON.parse(item.horizontalDetailImgs || "[]")
            : JSON.parse(item.detailImgs || "[]");
          this.storeUrl =
            this.$route.query.size === "vertical"
              ? item.storeUrl
              : item.horizontalStoreUrl;
        });
    },
  },
});
</script>